// ServicePage component - Converted from pages/service.vue
// Uses shared section components instead of a simple placeholder block
import React from 'react';
import HeaderOne from '../components/HeaderOne';
import CallToActionThree from '../../components/CallToActionThree.jsx';
import Footer from '../components/Footer';
import PageHeader from '../../components/PageHeader.jsx';
import ServiceFour from '../../components/ServiceFour.jsx';
import FaqOne from '../../components/FaqOne.jsx';
import TrustedOne from '../../components/TrustedOne.jsx';
const ServicePage: React.FC = () => {
  React.useEffect(() => {
  }, []);

  return (
    <>
      <HeaderOne />
      <PageHeader title="Services" />
      {/* Services We Offer section */}
      <ServiceFour />
      {/* Trusted statistics banner */}
      <TrustedOne />
      {/* FAQ / emergency call section */}
      <FaqOne />
      {/* CTA block same style as home page */}
      <CallToActionThree />
      <Footer />
    </>
  );
};

export default ServicePage;
